export default __webpack_public_path__ + "static/char-s-20-ko-d586249ed33cee134d96633a8d462bd6.png";